export const args = {
    text: 'https://www.bluelearn.in',
};
